import PropTypes from 'prop-types'
import { FormContext, useFormProvider } from './useForm'

export default function Form({ component: Component, onSubmit, validate }) {
  const data = useFormProvider(onSubmit, validate)

  return (
    <FormContext.Provider value={data}>
      <Component {...data} />
    </FormContext.Provider>
  )
}

Form.propTypes = {
  component: PropTypes.elementType.isRequired,
  onSubmit: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
}
